import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {ShoppingCart} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

type OrdersMenuConfig = {
  hasOrderManagement: boolean;
  hasLegacyOrderManagement: boolean;
};

export const getOrdersMenu = ({
  hasOrderManagement = false,
  hasLegacyOrderManagement = false,
}: OrdersMenuConfig): MenuItemConfig => {
  const hasOrderAccess = hasOrderManagement || hasLegacyOrderManagement;

  const menuItems = {
    type: 'parent',
    label: 'shipment.menu.items.order',
    multiplyLabel: true,
    icon: markRaw(ShoppingCart),
    show: () => hasOrderAccess,
    children: [
      {
        type: 'internal',
        label: 'overview',
        to: {
          name: 'orders-overview',
        },
        activeRouteNameAliases: ['orders-overview'],
        show: () => hasOrderAccess,
      },
      {
        type: 'internal',
        to: {
          name: 'addresses',
        },
        label: 'location.addressBook.addressBook',
        show: () => hasOrderManagement,
      },
      {
        type: 'internal',
        label: 'orders.import.manual',
        to: {
          name: 'orders-v1-import-overview',
        },
        activeRouteNameAliases: ['orders-v1-import-edit', 'orders-v1-import-overview'],
        show: () => !hasOrderManagement,
      },
      {
        type: 'internal',
        label: 'orders.import.manual',
        to: {
          name: 'orders-csv-import',
        },
        activeRouteNameAliases: ['orders-csv-import'],
        show: () => hasOrderManagement,
      },
    ],
  };

  return menuItems;
};
